import {
    LIST_OFIJUS,
    LIST_OFIJUS_SUCCESS,
    LIST_OFIJUS_ERROR,
    ADD_OFIJUS,
    SAVE_OFIJUS,
    SAVE_OFIJUS_SUCCESS,
    SAVE_OFIJUS_ERROR,
    DELETE_OFIJUS,
    DELETE_OFIJUS_SUCCESS,
    DELETE_OFIJUS_ERROR,
    EDIT_OFIJUS,
    UPDATE_OFIJUS,
    UPDATE_OFIJUS_SUCCESS,
    UPDATE_OFIJUS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import ofijusData from '../data/ofijus';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS, MSG_ERROR_SERVER } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'ofiju';

//LISTAR OFIJUS
export function listOfijusAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listOfijus() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const ofijus = response.data;
            //const ofijus = ofijusData;
            //Llamo al dispatch
            dispatch( listOfijusSuccess(ofijus.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listOfijusError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listOfijus = () => ({
    type: LIST_OFIJUS,
    payload: true
});

const listOfijusSuccess = ofijus => ({
    type: LIST_OFIJUS_SUCCESS,
    payload: ofijus
});

const listOfijusError = error => ({
    type: LIST_OFIJUS_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addOfijusAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addOfijus(false) );
        //Abro el formulario
        showForm();
    }
}

const addOfijus = isEdit => ({
    type: ADD_OFIJUS,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveOfijusAction(ofiju, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveOfijus() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, ofiju);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveOfijusSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveOfijusError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveOfijus = () => ({
    type: SAVE_OFIJUS,
    payload: true
});


const saveOfijusSuccess = ofiju => ({
    type: SAVE_OFIJUS_SUCCESS,
    payload: ofiju
});

const saveOfijusError = error => ({
    type: SAVE_OFIJUS_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editOfijusAction(ofiju, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editOfijus(ofiju) );
        //Abro el formulario
        showForm();
    }
}

const editOfijus = ofiju => ({
    type: EDIT_OFIJUS,
    payload: ofiju
});

//UPDATE AUDIENCE CATEGORY
export function updateOfijusAction(ofiju, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateOfijus() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${ofiju.id}`, ofiju);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateOfijusSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateOfijusError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateOfijus = () => ({
    type: UPDATE_OFIJUS,
    payload: true
});

const updateOfijusSuccess = ofiju => ({
    type: UPDATE_OFIJUS_SUCCESS,
    payload: ofiju
});

const updateOfijusError = error => ({
    type: UPDATE_OFIJUS_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteOfijusAction(ofiju) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteOfijus() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${ofiju.id}`);
            const response = await clienteAxios.put(`/${controller}/${ofiju.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteOfijusSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteOfijusError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteOfijus = () => ({
    type: DELETE_OFIJUS,
    payload: true
});

const deleteOfijusSuccess = ofiju => ({
    type: DELETE_OFIJUS_SUCCESS,
    payload: ofiju
});

const deleteOfijusError = error => ({
    type: DELETE_OFIJUS_ERROR,
    payload: error
});